module.exports = __webpack_public_path__ + "47946de4e56d81017c604dab880b49ad.svg";